module.exports = __webpack_public_path__ + "static/responsible-gaming-bb61d4e58c0613af1cb3b3fa9f2e0edb.svg";